import { ManagerEnum } from '@app/shared/enum/Manager.enum';
import * as i0 from "@angular/core";
var AuthStorageService = /** @class */ (function () {
    function AuthStorageService() {
    }
    Object.defineProperty(AuthStorageService.prototype, "authUser", {
        get: function () {
            return this._authUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthStorageService.prototype, "isManagerDCF", {
        get: function () {
            return this._authUser.gestor === ManagerEnum.DCF;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthStorageService.prototype, "isAuthUserError", {
        get: function () {
            return this._authError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthStorageService.prototype, "filterByManager", {
        get: function () {
            return this._filterByManager;
        },
        set: function (value) {
            if (value && !this.isManagerDCF) {
                throw new Error('Gerente não possui permissão para mudar o filtro por Gestor');
            }
            this._filterByManager = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthStorageService.prototype, "isLoadBoletaList", {
        get: function () {
            return this._isLoadBoletaList;
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @description método utilizado para se comunicar com o Local Storage
     */
    AuthStorageService.prototype.loadStorage = function () {
        try {
            if (!this._authUser) {
                this._authUser = JSON.parse(localStorage.getItem('authUser'));
                this._authError = false;
            }
        }
        catch (error) {
            this._authError = true;
        }
    };
    /**
    * @description método utilizado para identificar o gerente DCF
    */
    AuthStorageService.prototype.checkManagerDCF = function () {
        if (!this.isManagerDCF) {
            this.filterByManager = null;
        }
    };
    /**
     *
     * @param tableFilter é utilizado para filtrar os dados da Busca
     */
    AuthStorageService.prototype.checkLoadBoletaList = function (tableFilter) {
        var isTradeType = !!(tableFilter.tradeTypes && Array.isArray(tableFilter.tradeTypes) && tableFilter.tradeTypes.length > 0);
        var isOrderNumber = !!(tableFilter.ordemNumbers && Array.isArray(tableFilter.ordemNumbers) && tableFilter.ordemNumbers.length > 0);
        this._isLoadBoletaList = !!(isTradeType || isOrderNumber);
    };
    AuthStorageService.ngInjectableDef = i0.defineInjectable({ factory: function AuthStorageService_Factory() { return new AuthStorageService(); }, token: AuthStorageService, providedIn: "root" });
    return AuthStorageService;
}());
export { AuthStorageService };
